import { createTheme } from '@mui/material/styles';
import { arEG, enUS } from '@mui/material/locale';

const getTheme = (language) => {
    const isLtr = language === 'en';

    return createTheme(
        {
            direction: isLtr ? 'ltr' : 'rtl',
            shape: {
                borderRadius: 8,
            },
            palette: {
                primary: {
                    main: '#4880FF',
                },
                secondary: {
                    main: '#F5F5F5',
                },
                customGrey: {
                    insideInput: '#F1F4F9',
                    borderInput: '#D8D8D8',
                    text: '#666666',
                    tableHeading: "#FCFDFD",
                    pdfTable: '#f0f0f0'
                },
                text: {
                    primary: '#202224',
                    secondary: '#A6A6A6',
                    red: '#EA0234'
                },
                green: {
                    border: '#006600',
                    bg: '#00b300',
                    box: '#00B69B'
                },
                yellow: {
                    border: '#e6b800',
                    bg: '#ffcc00'
                },
                purple: {
                    box: '#6226EF'
                },
                red: {
                    border: '#991f00',
                    bg: '#ff471a',
                    box: '#EF3826'
                },
                blue: {
                    border: '#0052cc',
                    bg: '#3385ff'
                },
                dashbaord: {
                    red: "#f53d3d",
                    blue: "#0b6fda",
                    green: "#07c5a5",
                    purple: "#975eed"
                }
            },
            typography: {
                fontFamily: `'Notp', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
                    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
                    sans-serif`,
            },
        },
        isLtr ? enUS : arEG,

    );
};

export default getTheme;
